import { DemoProfile } from './types';

import User from 'modules/Auth/common/User.interface';
import Token from 'modules/Auth/common/Token.interface';

export const DEMO_USER_PK = 999001;

export function buildMockUser(profile: DemoProfile): User {
    return {
        pk: DEMO_USER_PK,
        id: DEMO_USER_PK,
        email: profile.email,
        first_name: profile.first_name,
        last_name: profile.last_name,
        username: profile.email,
        is_employee: false,
        groups: [],
        isImpersonator: false,
        // Must be truthy. Layout.tsx refetches the user in a loop while destination is empty;
        // /dashboard is the demo's landing destination so this just confirms it.
        destination: '/dashboard',
    };
}

export function buildMockToken(): Token {
    return {
        access: 'demo-access-token',
        refresh: 'demo-refresh-token',
        ephemeral_token: '',
        username: 'demo@collective.com',
        funnel_workflow_id: '',
        funnel_workflow_path: '',
        groups: [],
    };
}
